/** Cells with their own controls must not trigger the table row click (React events bubble through portals too) */
export function StopRowClick({ children }: { children: React.ReactNode }) {
  return (
    <div className="contents" onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  );
}
